module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "id": "_Слой_2",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 85 85"
    }
  }, [_c('g', {
    attrs: {
      "id": "_Слой_1-2"
    }
  }, [_c('g', [_c('circle', {
    staticClass: "cls-2",
    attrs: {
      "cx": "42.5",
      "cy": "42.5",
      "r": "42.5"
    }
  }), _c('g', [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M21.8,43.88c0-7.21,0-14.42,0-21.63,0-3.19,2.36-5.55,5.56-5.55,2.88,0,5.75,0,8.63,0,.12,0,.24,0,.36,0,.41,.04,.67,.33,.67,.72,0,.39-.27,.69-.68,.71-.47,.02-.94,.01-1.42,.01-2.54,0-5.08,0-7.62,0-2.32,0-4.06,1.7-4.06,4.03-.01,4.4,0,8.8,0,13.21,0,5.94,0,11.88,0,17.82,0,4.1,0,8.21,0,12.31,0,2.35,1.72,4.02,4.06,4.02,10.15,0,20.31,0,30.46,0,2.21,0,3.94-1.68,3.97-3.9,.02-1.98,0-3.97,0-5.95,0-4.9,0-9.8,0-14.7,0-4.85,0-9.69,0-14.54,0-2.7-.02-5.4,0-8.1,.02-2.44-1.67-4.19-4.11-4.19-2.89,0-5.78,0-8.67,0-.07,0-.14,0-.2,0-.49-.01-.81-.29-.81-.72,0-.43,.32-.72,.8-.73,1.03,0,2.05,0,3.08,0,1.96,0,3.92,0,5.87,0,3.09,0,5.47,2.38,5.47,5.46,0,4.54,0,9.07,0,13.61,0,9.92,0,19.85,0,29.77,0,2.98-2.32,5.41-5.19,5.44-2.17,.02-4.35,0-6.52,0-5.95,0-11.91,0-17.86,0-2.19,0-4.37,.01-6.56,0-2.71-.02-5.09-2.25-5.21-4.95-.08-1.86-.04-3.73-.04-5.59,0-5.52,0-11.04,0-16.57Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M42.51,28.11c3.94,0,7.88,0,11.83,0,.84,0,1.04,.21,1.04,1.06,0,7.88,0,15.77,0,23.65,0,.81-.23,1.04-1.03,1.04-7.9,0-15.79,0-23.69,0-.82,0-1.04-.22-1.04-1.03,0-7.9,0-15.79,0-23.69,0-.83,.21-1.04,1.02-1.04,3.96,0,7.91,0,11.87,0Zm-11.44,12.89c0,3.66,0,7.32,0,10.98,0,.36,.09,.46,.45,.45,1.17-.02,2.35-.01,3.52,0,.26,0,.35-.08,.35-.35-.01-.93-.01-1.86,0-2.79,.02-2.38,1.78-4.42,4.14-4.63,1.96-.18,3.94-.17,5.9,0,2.35,.2,4.11,2.16,4.19,4.51,.03,.94,.02,1.89,0,2.83,0,.33,.08,.44,.43,.44,1.13-.02,2.27-.02,3.4,0,.39,0,.5-.09,.5-.49-.01-7.3-.01-14.61,0-21.91,0-.35-.07-.48-.46-.48-7.32,.01-14.63,.01-21.95,0-.38,0-.47,.11-.46,.47,.01,3.66,0,7.32,0,10.98Zm11.42,11.42c1.75,0,3.51,0,5.26,0,.34,0,.43-.1,.43-.43-.02-.88,0-1.75,0-2.63-.02-1.82-1.35-3.25-3.16-3.31-1.68-.06-3.38-.06-5.06,0-1.81,.07-3.12,1.51-3.13,3.33,0,.88,.01,1.75,0,2.63,0,.32,.08,.41,.41,.41,1.75-.01,3.51,0,5.26,0Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M42.52,23.87c-2.77,0-5.53,0-8.3,0-.19,0-.38,.02-.56-.07-.33-.16-.48-.44-.4-.8,.08-.39,.34-.57,.73-.57,.94,0,1.89,0,2.83,0,.47,0,.95-.01,1.42,0,.3,.01,.39-.09,.39-.39-.01-2.59,0-5.18,0-7.77,0-.81,0-1.62,0-2.43,0-.57,.27-.84,.85-.84,2.01,0,4.02,0,6.03,0,.66,0,.9,.25,.9,.9,0,3.35,0,6.69,0,10.04,0,.39,.11,.5,.5,.49,1.35-.02,2.7,0,4.05,0,.35,0,.65,.1,.79,.44,.2,.49-.13,.98-.71,.99-.84,.02-1.67,0-2.51,.01-2,0-3.99,0-5.99,0,0,0,0,0,0,0Zm-2.45-6.45c0,1.54,0,3.08,0,4.61,0,.29,.07,.4,.38,.4,1.38-.02,2.75-.01,4.13,0,.29,0,.39-.07,.39-.38-.01-3.06,0-6.12,0-9.19,0-.31-.08-.42-.4-.41-1.36,.02-2.73,.02-4.09,0-.35,0-.42,.12-.42,.44,.02,1.51,0,3.02,0,4.53Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M42.47,61.16c-3.91,0-7.83,0-11.74,0-.19,0-.38,0-.56-.04-.36-.08-.57-.4-.53-.76,.04-.37,.26-.58,.62-.64,.13-.02,.27-.01,.4-.01,7.88,0,15.76,0,23.65,0,.71,0,1.05,.23,1.06,.71,0,.49-.35,.74-1.08,.74-3.94,0-7.88,0-11.82,0Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M42.47,43.69c-3.11-.01-5.61-2.52-5.61-5.63,0-3.11,2.55-5.64,5.66-5.63,3.11,.01,5.62,2.56,5.6,5.68-.02,3.11-2.53,5.59-5.65,5.58Zm4.2-5.58c.02-2.31-1.82-4.2-4.12-4.23-2.31-.03-4.22,1.86-4.24,4.16-.01,2.3,1.84,4.18,4.15,4.2,2.32,.02,4.18-1.81,4.21-4.13Z"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fb40b75","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIcon/iconsTemplate/contents/dashboard/professiy.vue
// module id = 7231a017d6c6435d6b8f
// module chunks = 89